import { render, staticRenderFns } from "./CashiersLimitsCollapse.vue?vue&type=template&id=06c70ece"
import script from "./CashiersLimitsCollapse.vue?vue&type=script&lang=js"
export * from "./CashiersLimitsCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports